import { observer } from 'mobx-react';
import React from 'react';

export const ToBeDone = observer(function() {
	return <div style={{textAlign: 'center', color: 'red', alignSelf: 'center', height: '100%', display: 'flex', alignItems: 'center', fontSize: 'larger'}}>
		Diese Seite existiert noch nicht.
	</div>;
});
